(function () {
  const consentHint = document.querySelector('.sw-klaviyo-consent');
  if (!consentHint) return;

  const KLAVIYO_SELECTOR = '[class*="klaviyo-form-"]';

  const isFormRendered = () => {
    const form = document.querySelector(KLAVIYO_SELECTOR);
    return !!(form && form.children.length > 0);
  };

  const hideHint = () => {
    consentHint.style.display = 'none';
  };

  if (isFormRendered()) {
    hideHint();
  } else {
    const form = document.querySelector(KLAVIYO_SELECTOR);
    if (form) {
      const observer = new MutationObserver(() => {
        if (isFormRendered()) {
          hideHint();
          observer.disconnect();
        }
      });
      observer.observe(form, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 20000);
    }
  }

  // Seite neu laden, wenn Nutzer Consent-Auswahl ändert.
  // composedPath() nötig, weil Consentmo-Buttons im Shadow DOM leben.
  document.addEventListener('click', (e) => {
    const btn = e.composedPath().find(el =>
      el.matches && el.matches('.isense-cc-submit-consent, .isense-cc-settings')
    );
    if (!btn) return;

    setTimeout(() => window.location.reload(), 500);
  });
})();